package com.exura.pages.planConstructor

import androidx.compose.runtime.Composable
import com.exura.components.layouts.plan.PlanConstructorLayoutScope
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext



@Page("/planConstructor")
@Layout(".components.layouts.plan.PlanConstructorLayout")
@Composable
fun PlanConstructorLayoutScope.PlanConstructorIndexPage() {
    val ctx = rememberPageContext()
}
